import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/colors")({
  component: () => <Navigate to="/admin/design-system/colors" />,
});
